export default __webpack_public_path__ + "static/milestone-bg-81862df61b4361d7acb68e5c17076ea4.png";